var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapInitialized),expression:"mapInitialized"}],ref:"map",style:({ minHeight: _vm.minHeight }),attrs:{"center":_vm.center,"zoom":19,"options":{
        draggable: false,
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        keyboardShortcuts: false,
        scrollwheel: false,
    },"map-type-id":"satellite"}},[_c('GmapMarker',{attrs:{"position":_vm.center}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }